// Which lots each tab on the Positions page shows.
//
// Brian, 20 September 2026: *"ARTL and NVVE are closed on positions"* — said to
// correct a diagnosis built on their being open. Going to read the tab that
// word comes from turned up a label that does not test what it says.
//
// **`Closed` tested the deal's status as well as the lot's.** A closed lot on a
// deal still marked Active was in neither `Open` nor `Closed`, so a reader who
// had looked at both had every reason to believe they had seen the book, and
// had not. §0.17's rule for the fourth time on this codebase: a label may not
// name a condition the code does not test.
//
// The rows are not the problem and are left exactly as they were. Every sale
// writes a closing lot, so a tab meaning plain `!is_open` would bury the
// positions that actually ended under Hilbert Group's 293 disposal rows — the
// filter was answering a useful question under the wrong name. So the name
// changes to the question, and `hiddenFromClosedDeals` counts what the tab is
// holding back so the page can say so instead of leaving it to be found.

export const OPEN = "Open";
export const CLOSED_DEALS = "Closed deals";
export const ALL = "All";
export const TABS = [OPEN, CLOSED_DEALS, ALL];

const finished = (status) => status === "Closed" || status === "Exited";

/** A lot that is closed AND whose deal is finished — what the middle tab shows. */
export const closedOnFinishedDeal = (lot) =>
  !lot.is_open && finished(lot.deal_status);

/** The lots one tab shows. */
export const filterLots = (lots, tab) => (lots || []).filter((lot) => {
  if (tab === OPEN) return lot.is_open;
  if (tab === CLOSED_DEALS) return closedOnFinishedDeal(lot);
  return true;
});

/** Closed lots the middle tab leaves out, because their deal is still running. */
export const hiddenFromClosedDeals = (lots) =>
  (lots || []).filter((lot) => !lot.is_open && !closedOnFinishedDeal(lot));
